import React, { useEffect, useState, useContext } from "react";
import { RootContext } from "../../RootContextProvider";
import { Link } from "react-router-dom";
import { Row, Col, Avatar, Skeleton } from "antd";
import "./Analytics.css";
import PageChart from "./Graphs/PageChart";
import { UserOutlined } from "@ant-design/icons";
import LinksSection from "./LinksSection";
import FilterDates from "./FilterDate";
import { getAnalyticsByPageIDAndDate } from "../../utils/stats";
import { getEndDateAndInterval } from "../../utils/utils";

const Analytics = () => {
  const { account, pages } = useContext(RootContext);
  const [loading, setLoading] = useState(true);
  const [, setFilterDate] = useState("7 derniers jours");
  const [pageStats, setPageStats] = useState();
  const [linkStats, setLinkStats] = useState();
  const [dates, setDates] = useState([]);

  useEffect(() => {
    const loadStats = async () => {
      try {
        let date = getEndDateAndInterval("0");
        let stats = await getAnalyticsByPageIDAndDate(
          pages.PageID,
          date.endDate,
          date.interval
        );
        setDates(stats.dates);
        setPageStats(stats.eventsPage);
        setLinkStats(stats.linkClicks);
        setLoading(false);
      } catch (e) {
        console.log(e);
      }
    };
    if (account.IsPaying) {
      loadStats();
    } else {
      setLoading(false);
    }
    // load stats
    // eslint-disable-next-line
  }, []);

  const onDateChange = async (dateSelected) => {
    // reload stats
    setLoading(true);
    setFilterDate(dateSelected);
    let date = getEndDateAndInterval(dateSelected);
    let stats = await getAnalyticsByPageIDAndDate(
      pages.PageID,
      date.endDate,
      date.interval
    );
    setDates(stats.dates);
    setPageStats(stats.eventsPage);
    setLinkStats(stats.linkClicks);
    setLoading(false);
    // set stats
    console.log("handle date change");
  };

  if (account.IsPaying) {
    return (
      <div className="main-container analytics-container">
        <div className="header-analytics">
          <div className="primary-title">Statistiques</div>
          <FilterDates onDateChange={onDateChange} disabled={loading} />
        </div>
        <Row gutter={20} className="global-map-container">
          <Col xl={24} lg={24} md={24} sm={24} xs={24}>
            <div className="row-page-stats">
              <div className="pagePicture">
                {" "}
                <Avatar
                  size={57}
                  src={pages.PagePicture}
                  icon={<UserOutlined />}
                />
              </div>
              <div className="pageName">linksight.me/{pages.PageName}</div>
              <div className="page-stats">
                {/* <div className="pageviews">4587</div>
              <div className="clicks">528</div> */}
              </div>
            </div>
            {!loading && pageStats && dates ? (
              <PageChart pageStats={pageStats} dates={dates} />
            ) : (
              ""
            )}
            {loading ? <Skeleton active /> : ""}
          </Col>
          {/* <Col xl={8} lg={8} md={24} sm={24} xs={24}>
          OS stats
        </Col> */}
        </Row>
        <Row gutter={20} className="global-links-analytics">
          <div className="secondary-title">Statistiques des liens</div>
          <LinksSection loading={loading} linkStats={linkStats} dates={dates} />
        </Row>
      </div>
    );
  } else {
    return (
      <div className="main-container analytics-container">
        <div className="header-analytics">
          <div className="primary-title">Statistiques</div>
          <FilterDates onDateChange={onDateChange} disabled={true} />
        </div>

        <div className="upgrade-section-bg">
          <div className="banner-upgrade-stats">
            <b>Fonctionnalité Premium</b>
            📈 Suivez et analysez les performances de votre page Linksight dès
            maintenant.{" "}
            <Link to="/billing" style={{ width: "fit-content" }}>
              <div className="upgrade-btn-banner">
                Débloquez les statistiques
              </div>
            </Link>
          </div>
        </div>
      </div>
    );
  }
};

export default Analytics;
